import { createFileRoute, redirect } from '@tanstack/react-router';

// De sponsorpagina is opgegaan in /admin/settings
export const Route = createFileRoute('/admin/sponsor')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/settings', replace: true });
  },
});
